export default class {
  static fetchAverageCrankset(): number {
    return 170
  }
}
